import { theme } from '@chakra-ui/react';

import tailwindColors from './tailwindColors';

export const colors = {
  ...theme.colors,
  ...tailwindColors,
  brand: {
    50: '#cfe5e1',
    100: '#aed3cc',
    200: '#9dcac2',
    300: '#8dc1b8',
    400: '#7cb8ae',
    500: '#5BA699',
    600: '#48867b',
    700: '#3f756c',
    800: '#37645d',
    900: '#25433e',
  },
  culturedWhite: '#f4f5f7',
  keppelGreen: '#39b6a3',
  primary: {
    50: '#cfe5e1',
    100: '#aed3cc',
    200: '#9dcac2',
    300: '#8dc1b8',
    400: '#7cb8ae',
    500: '#5BA699',
    600: '#48867b',
    700: '#3f756c',
    800: '#37645d',
    900: '#25433e',
  },
  approvedTopSearches: '#F5A839',
  disapprovedTopSearches: '#7B7B7B',
  lightGreen: '#5BA6990F',
  lightGoldenrodYellow: '#fef9d2',
  platinum: '#e6e6e5',
  violetWeb: '#ff9df5',
  grannySmithApple: '#b7ffba',
  wildBlueYonder: '#b2b4d5',
  gray: tailwindColors.blueGray,
  success: theme.colors.green,
  error: theme.colors.red,
  warning: theme.colors.yellow,
};
